<template>
  <div
    v-show="isOpen"
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="isOpen"
        class="fixed inset-0 transition-opacity"
        @click="close"
      >
        <div class="absolute inset-0 bg-gray-800 opacity-75"></div>
      </div>
    </transition>

    <transition
      enter-active-class="ease-out duration-300"
      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100 translate-y-0 sm:scale-100"
      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    >
      <div
        v-show="isOpen"
        class="p-5 bg-white rounded-lg overflow-y-auto shadow-xl transform transition-all sm:w-full"
      >
        <div class="pb-2 sm:pb-0">
          <div class="absolute top-0 right-0 pt-4 pr-4">
            <button
              @click="close"
              type="button"
              class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
            >
              <svg
                class="h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <ul class="flex border-b">
          <li v-for="(tab_name, tab_key) in tabNames" v-bind:class=" (activeTab === tab_key) ? '-mb-px mr-1' : 'mr-1'">
            <a class="bg-white inline-block py-2 px-4 font-semibold" v-bind:class=" (activeTab === tab_key) ? 'border-l border-t border-r rounded-t text-blue-700' : 'text-blue-500 hover:text-blue-800'" @click="activeTab=tab_key">{{tab_name}}</a>
          </li>
        </ul>
        <div class="overflow-y-auto bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" style="height: 80vh;">
          <table v-for="(tab_name, tab_key) in tabNames" class="border-collapse w-full" :class="{'hidden' : activeTab !== tab_key}">
              <thead>
                  <tr>
                      <th v-for="(header_name) in tabHeaders[tab_key]" class="p-3 font-bold uppercase bg-gray-200 text-gray-600 border border-gray-300 hidden lg:table-cell">{{header_name}}</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="(row, row_index) in tabMaterials[tab_key]" class="bg-white lg:hover:bg-gray-100 flex lg:table-row flex-row lg:flex-row flex-wrap lg:flex-no-wrap mb-5 lg:mb-0">
                      <td v-for="(header_name, header_key) in tabHeaders[tab_key]" class="sm:pt-7 w-full lg:w-auto text-gray-800 text-left border border-b block lg:table-cell relative lg:static lg:pt-3 px-3 pt-10"
                      :class="{'text-right': !isNaN(row[header_key])}"
                      >
                          <span v-if="header_key != 'link'" class="lg:hidden absolute top-0 left-0 bg-blue-200 px-2 py-1 text-xs font-bold uppercase">{{header_name}}</span>
                          <span v-if="header_key != 'link'">{{printFormattedValue(row[header_key], header_key)}}</span>
                          <a v-if="header_key == 'link' && row[header_key]" :href="row[header_key]" class="text-blue-500 cursor-pointer" >{{header_name}}</a>
                      </td>
                  </tr>
              </tbody>
          </table>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String },
  },
  created() {
    const onEscape = (e) => {
      if (this.open && e.keyCode === 27) {
        this.close();
      }
    };
    document.addEventListener('keydown', onEscape);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', onEscape);
    });
  },
  data() {
    return {
      activeTab: 'composites',
      isOpen: false,
      tabNames: {
        composites: "Acabado compuesto"
        ,doors: "Puertas"
        ,slabs: "Losas"
        ,walls: "Muros"
        ,windows: "Ventanas"
      },
      tabMaterials : {
        composites: window.constants.getComposites()
        ,doors: window.constants.getDoors()
        ,slabs: window.constants.getSlabs()
        ,walls: window.constants.getWalls()
        ,windows: window.constants.getWindows()
      },
      tabHeaders: {
        composites: {
          id: "#"
          , name: "Nombre" 
          , r_value: "Valor R Nominal (f°*ft^2*hr/BTU)"
          , u_value: "Valor U (W/m^2K)"
          , thermal_resistance: "Resistencia Térmica"
          , link: "Ficha técnica"
        }
        , doors: {
          id: "#"
          , name: "Nombre"
          , r_value: "Valor R Nominal (f°*ft^2*hr/BTU)"
          , u_value: "Valor U (W/m^2K)"
          , thermal_resistance: "Resistencia Térmica"
          , complies_2001: "¿Cumple la NMX-C-460-ONNCCE-2001?"
          , link: "Ficha técnica"
        }
        , slabs: {
          id: "#"
          , name: "Nombre" 
          , r_value: "Valor R Nominal (f°*ft^2*hr/BTU)" 
          , u_value: "Valor U (W/m^2K)" 
          , thermal_resistance: "Resistencia Térmica" 
          , complies_2001: "¿Cumple la NMX-C-460-ONNCCE-2001?"
          , link: "Ficha técnica"
        }
        , walls: {
          id : "#"
          , name : "Nombre"
          , r_value : "Valor R Nominal (f°*ft^2*hr/BTU)"
          , u_value : "Valor U (W/m^2K)"
          , thermal_resistance : "Resistencia Térmica"
          , complies_2001 : "¿Cumple la NMX-C-460-ONNCCE-2001?"
          , link: "Ficha técnica"
        }
        , windows: {
          id: "#"
          , name: "Nombre"
          , thickness: "Espesor (mm)"
          , cgcs_value: "Ganancia de Calor Solar (CGCS)"
          , shade_coefficient: "Coeficiente de Sombreado (CS)"
          , u_value: "Valor U (W/m^2K)"
          , link: "Ficha técnica"
        }
      }
    };
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    printFormattedValue: function(valueToPrint, header_key) {
      switch (header_key) {
        case 'r_value':
          return valueToPrint.toFixed(2);
        case 'thermal_resistance':
        case 'u_value':
          return valueToPrint.toFixed(4);
        default:
          return valueToPrint;
      }

    }
  },
  computed: {
  },
};
</script>
